var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "member-id--wrapper m-prfilemtb" }, [
    _c("div", { staticClass: "md-layout md-gutter" }, [
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-xlarge-size-33 md-large-size-33 md-small-size-100"
        },
        [
          _c(
            "div",
            { staticClass: "card name" },
            [
              _c("div", { staticClass: "avatar" }, [
                _vm.member.imageURL
                  ? _c("img", {
                      staticClass: "circle-image",
                      attrs: { src: _vm.member.imageURL, alt: "member photo" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.member.imageURL
                  ? _c("img", {
                      staticClass: "circle-image",
                      attrs: {
                        src: require("../assets/person.png"),
                        alt: "member photo"
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sub-title md-body-1 capitalize" }, [
                _vm._v(_vm._s(_vm.member.memberType))
              ]),
              _vm._v(" "),
              _vm.member.isDeleted && _vm.member.isDeleted.status === true
                ? [
                    _c(
                      "div",
                      { staticClass: "md-body-1 unsubscribe font-18" },
                      [
                        _vm._v(
                          "Deleted: " +
                            _vm._s(
                              _vm._f("momentDate")(_vm.member.isDeleted.when)
                            )
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.member.member_status == true
                ? [
                    _c(
                      "div",
                      { staticClass: "md-title" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.member.first) +
                            " " +
                            _vm._s(_vm.member.last) +
                            "\n                "
                        ),
                        _vm.memberFlag == "Flagged"
                          ? [
                              _c(
                                "svg",
                                {
                                  staticClass: "flag-svg",
                                  attrs: {
                                    id: "cis-flag-alt",
                                    viewBox: "0 0 512 512"
                                  }
                                },
                                [
                                  _c("polygon", {
                                    staticClass: "ci-primary",
                                    attrs: {
                                      fill: "var(--ci-primary-color, #CC0000)",
                                      points:
                                        "432 72 104 72 104 16 56 16 56 496 104 496 104 344 432 344 432 328 344 208 432 88 432 72"
                                    }
                                  })
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.member.roles &&
                    _vm.member.roles.length &&
                    _vm.member.organization
                      ? _c("div", { staticClass: "md-body-1 capitalize" }, [
                          _vm._v(
                            _vm._s(_vm.member.roles) +
                              ", " +
                              _vm._s(_vm.member.organization)
                          )
                        ])
                      : _vm.member.roles &&
                        _vm.member.roles.length &&
                        !_vm.member.organization
                      ? _c("div", { staticClass: "md-body-1 capitalize" }, [
                          _vm._v(_vm._s(_vm.member.roles))
                        ])
                      : !_vm.member.roles && _vm.member.organization
                      ? _c("div", { staticClass: "md-body-1 capitalize" }, [
                          _vm._v(_vm._s(_vm.member.organization))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.member.member_status == true
                      ? _c(
                          "div",
                          { staticClass: "md-body-1 active-status font-18" },
                          [_vm._v("Active")]
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.member.member_status == false
                ? [
                    _c(
                      "div",
                      { staticClass: "md-body-1 unsubscribe font-18" },
                      [_vm._v("Inactive")]
                    )
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card skills" }, [
            (_vm.member.isDeleted && _vm.member.isDeleted.status === true) ||
            (_vm.member.unsubscribe &&
              _vm.member.unsubscribe.status === "unsubscribed")
              ? _c("ul", { staticClass: "card-killsblock" }, [
                  _c("li", [_vm._v("Status:")]),
                  _vm._v(" "),
                  _c("li", [
                    _vm.member.isDeleted && _vm.member.isDeleted.status === true
                      ? _c("span", [_c("span", [_vm._v("Deleted")])])
                      : _vm.member.unsubscribe &&
                        _vm.member.unsubscribe.status === "unsubscribed"
                      ? _c("span", [
                          _c("span", [
                            _vm._v("Unsubscribed "),
                            _c("br"),
                            _vm._v(
                              _vm._s(
                                _vm._f("momentDate")(
                                  _vm.member.unsubscribe.when
                                )
                              )
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              : _vm._e(),
            _c("ul", { staticClass: "card-killsblock" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("li", [
                _vm.$lodash.has(_vm.member.request, "totalRequest")
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.member.request.totalRequest))
                    ])
                  : _c("span", [_vm._v("N/A")]),
                _vm._v(" "),
                _c("br"),
                _vm.$lodash.has(_vm.member.request, "lastRequest")
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("momentDate")(_vm.member.request.lastRequest)
                        )
                      )
                    ])
                  : _c("span", [_vm._v("N/A")])
              ])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "card-killsblock" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("li", [
                _vm.$lodash.has(
                  _vm.member.requestReceived,
                  "lastRequestReceived"
                )
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("momentDate")(
                            _vm.member.requestReceived.lastRequestReceived
                          )
                        )
                      )
                    ])
                  : _c("span", [_vm._v("N/A")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm.$lodash.has(_vm.member, "nextEngagementDate")
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("momentDate")(_vm.member.nextEngagementDate)
                        )
                      )
                    ])
                  : _c("span", [_vm._v("N/A")])
              ])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "card-killsblock" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("li", [
                _vm.$lodash.has(_vm.member.response, "totalResponse")
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.member.response.totalResponse))
                    ])
                  : _c("span", [_vm._v("N/A")]),
                _c("br"),
                _vm.$lodash.has(_vm.member.response, "lastResponse")
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("momentDate")(_vm.member.response.lastResponse)
                        )
                      )
                    ])
                  : _c("span", [_vm._v("N/A")])
              ])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "card-killsblock" }, [
              _c("li", [_vm._v("Feedback Given:")]),
              _vm._v(" "),
              _c("li", [
                _vm.member.feedback_given > 0
                  ? _c("span", [_vm._v(_vm._s(_vm.member.feedback_given))])
                  : _c("span", [_vm._v("N/A")])
              ])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "card-killsblock" }, [
              _c("li", [_vm._v("Feedback Received:")]),
              _vm._v(" "),
              _c("li", [
                _vm.member.feedback_received > 0
                  ? _c("span", [_vm._v(_vm._s(_vm.member.feedback_received))])
                  : _c("span", [_vm._v("N/A")])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-xlarge-size-66 md-large-size-66 md-small-size-100"
        },
        [
          _c(
            "form",
            {
              staticClass: "textlable-spaceright",
              attrs: { "data-vv-scope": "form-profile" },
              on: {
                change: function($event) {
                  $event.preventDefault()
                  return _vm.saveDetail("form-profile")
                }
              }
            },
            [
              _c("div", { staticClass: "card local" }, [
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Community")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community w-50" },
                        [
                          _c(
                            "md-select",
                            {
                              attrs: {
                                disabled: _vm.member.isDeleted.status == true,
                                name: "community",
                                placeholder: "Community",
                                id: "community"
                              },
                              on: {
                                "md-closed": function($event) {
                                  return _vm.changeCommunity()
                                }
                              },
                              model: {
                                value: _vm.newComm,
                                callback: function($$v) {
                                  _vm.newComm =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "newComm"
                              }
                            },
                            _vm._l(_vm.allCommunities, function(
                              singleCommunity
                            ) {
                              return _c(
                                "md-option",
                                {
                                  key: singleCommunity._id,
                                  attrs: { value: singleCommunity._id }
                                },
                                [_vm._v(_vm._s(singleCommunity.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Circles")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item remove-perfect-tense" },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community textareaAfter" },
                        [
                          _c("md-textarea", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "circles",
                              placeholder: "Circles...",
                              "md-autogrow": ""
                            },
                            on: {
                              input: function($event) {
                                _vm.circleList = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.circleList,
                              callback: function($$v) {
                                _vm.circleList = $$v
                              },
                              expression: "circleList"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-helper-text" }, [
                            _vm._v("Multiple skills must be comma(,) separated")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Groups")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item remove-perfect-tense custom-textarea"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community textareaAfter" },
                        [
                          _c("md-textarea", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate.continues",
                                value: "max:500",
                                expression: "'max:500'",
                                modifiers: { continues: true }
                              }
                            ],
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              maxlength: 500,
                              name: "groups",
                              placeholder: "Groups",
                              "md-autogrow": ""
                            },
                            on: {
                              input: function($event) {
                                _vm.groups = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.groups,
                              callback: function($$v) {
                                _vm.groups = $$v
                              },
                              expression: "groups"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "md-helper-text counter-padding" },
                            [
                              _vm._v(
                                "Multiple group must be comma(,) separated"
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Member Type")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community w-50" },
                        [
                          _c(
                            "md-select",
                            {
                              staticClass: "capitalize",
                              attrs: {
                                disabled: _vm.member.isDeleted.status == true,
                                name: "memberType",
                                placeholder: "Member Type",
                                id: "memberType"
                              },
                              on: {
                                "md-closed": function($event) {
                                  return _vm.saveDetail2(
                                    "memberType",
                                    _vm.memberType
                                  )
                                }
                              },
                              model: {
                                value: _vm.memberType,
                                callback: function($$v) {
                                  _vm.memberType =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "memberType"
                              }
                            },
                            [
                              _c("md-option", { attrs: { value: "Advisor" } }, [
                                _vm._v("Advisor")
                              ]),
                              _vm._v(" "),
                              _c("md-option", { attrs: { value: "Member" } }, [
                                _vm._v("Member")
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-option",
                                { attrs: { value: "Referral" } },
                                [_vm._v("Referral")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Member Flag")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community w-50" },
                        [
                          _c(
                            "md-select",
                            {
                              staticClass: "capitalize",
                              attrs: {
                                disabled: _vm.member.isDeleted.status == true,
                                name: "memberFlag",
                                placeholder: "Member Flag",
                                id: "memberFlag"
                              },
                              on: {
                                "md-closed": function($event) {
                                  return _vm.saveDetail2(
                                    "memberFlag",
                                    _vm.memberFlag
                                  )
                                }
                              },
                              model: {
                                value: _vm.memberFlag,
                                callback: function($$v) {
                                  _vm.memberFlag = $$v
                                },
                                expression: "memberFlag"
                              }
                            },
                            [
                              _c("md-option", { attrs: { value: "Flagged" } }, [
                                _vm._v("Flag Member")
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-option",
                                { attrs: { value: "Unflagged" } },
                                [_vm._v("Unflag Member")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Member Role")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "member_role",
                              placeholder: "Member Role",
                              "aria-label": "Member Role"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.member_role = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.member_role,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "member_role", $$v)
                              },
                              expression: "member.member_role"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Member Rank")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community textareaAfter" },
                        [
                          _c("md-textarea", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "member_rank",
                              placeholder: "Member Rank",
                              "md-autogrow": ""
                            },
                            on: {
                              input: function($event) {
                                _vm.member.member_rank = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.member_rank,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "member_rank", $$v)
                              },
                              expression: "member.member_rank"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-helper-text" }, [
                            _vm._v(
                              "Multiple member rank must be comma(,) separated"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Advice Area")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community textareaAfter" },
                        [
                          _c("md-textarea", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "advice_area",
                              placeholder: "Advice Area",
                              "md-autogrow": ""
                            },
                            on: {
                              input: function($event) {
                                _vm.member.advice_area = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.advice_area,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "advice_area", $$v)
                              },
                              expression: "member.advice_area"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-helper-text" }, [
                            _vm._v(
                              "Multiple Advice Area must be comma(,) separated"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Affinity")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community textareaAfter" },
                        [
                          _c("md-textarea", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "affinity",
                              placeholder: "Affinity",
                              "md-autogrow": ""
                            },
                            on: {
                              input: function($event) {
                                _vm.member.affinity = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.affinity,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "affinity", $$v)
                              },
                              expression: "member.affinity"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-helper-text" }, [
                            _vm._v(
                              "Multiple affinity must be comma(,) separated"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Property ID")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "propertyId",
                              placeholder: "Property Id"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.propertyId = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.propertyId,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "propertyId", $$v)
                              },
                              expression: "member.propertyId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Student ID")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "studentId",
                              placeholder: "Student Id"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.studentId = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.studentId,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "studentId", $$v)
                              },
                              expression: "member.studentId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row mprofile" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("First Name")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "first",
                              placeholder: "First Name"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.first = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.first,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "first", $$v)
                              },
                              expression: "member.first"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("form-profile.first"),
                                  expression: "errors.has('form-profile.first')"
                                }
                              ],
                              staticClass: "md-helper-text error"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.errors.first("form-profile.first"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Last Name")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "last",
                              placeholder: "Last Name"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.last = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.last,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "last", $$v)
                              },
                              expression: "member.last"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("form-profile.last"),
                                  expression: "errors.has('form-profile.last')"
                                }
                              ],
                              staticClass: "md-helper-text error"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.errors.first("form-profile.last"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-row mt-30 update-email-field" },
                  [
                    _c("div", { staticClass: "card-item md-subheading" }, [
                      _vm._v("Email Address")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                      },
                      [
                        _vm.isEmailLinkDisable
                          ? _c(
                              "md-field",
                              { staticClass: "create-community" },
                              [
                                _c("md-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|email",
                                      expression: "'required|email'"
                                    }
                                  ],
                                  attrs: {
                                    name: "email",
                                    placeholder: "Email Address"
                                  },
                                  on: {
                                    input: function($event) {
                                      _vm.member.emails = _vm.sanitizeInput(
                                        $event
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.member.emails,
                                    callback: function($$v) {
                                      _vm.$set(_vm.member, "emails", $$v)
                                    },
                                    expression: "member.emails"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "form-profile.email"
                                        ),
                                        expression:
                                          "errors.has('form-profile.email')"
                                      }
                                    ],
                                    staticClass: "md-helper-text error"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first("form-profile.email")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isEmailLinkDisable
                          ? _c("div", [
                              _vm.member.emails && _vm.member.emails.length
                                ? _c(
                                    "div",
                                    { staticClass: "card-item md-subheading" },
                                    [_vm._v(_vm._s(_vm.member.emails[0]))]
                                  )
                                : _c("div", {
                                    staticClass:
                                      "card-item md-subheading empty-dash light"
                                  })
                            ])
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.isEmailDisable &&
                    _vm.member.isDeleted.status == false &&
                    !_vm.member.unsubscribe
                      ? _c(
                          "div",
                          [
                            _c(
                              "md-button",
                              {
                                staticClass:
                                  "md-button md-red md-round md-accent md-theme-default",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.isEmailLinkDisable = true
                                  }
                                }
                              },
                              [_vm._v("Update email")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Email address 2")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: true,
                              name: "email_address2",
                              placeholder: "Email Address 2"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.email_address2 = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.email_address2,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "email_address2", $$v)
                              },
                              expression: "member.email_address2"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Email address 3")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: true,
                              name: "email_address3",
                              placeholder: "Email Address 3"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.email_address3 = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.email_address3,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "email_address3", $$v)
                              },
                              expression: "member.email_address3"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Phone")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "phoneNumbers",
                              placeholder: "Phone Numbers",
                              "aria-label": "Phone Numbers"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.phoneNumbers = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.phoneNumbers,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "phoneNumbers", $$v)
                              },
                              expression: "member.phoneNumbers"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Role")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "roles",
                              placeholder: "Role",
                              "aria-label": "Role"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.roles = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.roles,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "roles", $$v)
                              },
                              expression: "member.roles"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Role Description")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item remove-perfect-tense" },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community textareaAfter" },
                        [
                          _c("md-textarea", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate.continues",
                                value: "max:2000",
                                expression: "'max:2000'",
                                modifiers: { continues: true }
                              }
                            ],
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              maxlength: 2000,
                              name: "roleDescription",
                              placeholder: "Role Description",
                              "md-autogrow": ""
                            },
                            on: {
                              input: function($event) {
                                _vm.member.roleDescription = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.roleDescription,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "roleDescription", $$v)
                              },
                              expression: "member.roleDescription"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Organization")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "organization",
                              placeholder: "Organization",
                              "aria-label": "Organization"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.organization = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.organization,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "organization", $$v)
                              },
                              expression: "member.organization"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Organization Description")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item remove-perfect-tense" },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community textareaAfter" },
                        [
                          _c("md-textarea", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate.continues",
                                value: "max:2000",
                                expression: "'max:2000'",
                                modifiers: { continues: true }
                              }
                            ],
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              maxlength: 2000,
                              name: "organizationDescription",
                              placeholder: "Organization Description",
                              "md-autogrow": ""
                            },
                            on: {
                              input: function($event) {
                                _vm.member.organizationDescription = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.organizationDescription,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.member,
                                  "organizationDescription",
                                  $$v
                                )
                              },
                              expression: "member.organizationDescription"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("City")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "city",
                              placeholder: "City",
                              "aria-label": "City"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.city = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.city,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "city", $$v)
                              },
                              expression: "member.city"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("State")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "state",
                              placeholder: "State",
                              "aria-label": "State"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.state = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.state,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "state", $$v)
                              },
                              expression: "member.state"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Postal Code")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "postal_code",
                              placeholder: "Postal Code"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.postal_code = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.postal_code,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "postal_code", $$v)
                              },
                              expression: "member.postal_code"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Country")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "country",
                              placeholder: "Country",
                              "aria-label": "Country"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.country = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.country,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "country", $$v)
                              },
                              expression: "member.country"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Citizenship 1")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "citizenship1",
                              placeholder: "Citizenship 1"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.citizenship1 = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.citizenship1,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "citizenship1", $$v)
                              },
                              expression: "member.citizenship1"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Citizenship 2")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "citizenship2",
                              placeholder: "Citizenship 2"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.citizenship2 = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.citizenship2,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "citizenship2", $$v)
                              },
                              expression: "member.citizenship2"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Portal URL")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "portalURL",
                              placeholder: "Portal URL"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.portalURL = _vm.sanitizeUrl($event)
                              }
                            },
                            model: {
                              value: _vm.member.portalURL,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "portalURL", $$v)
                              },
                              expression: "member.portalURL"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Industry")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item remove-perfect-tense" },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community textareaAfter" },
                        [
                          _c("md-textarea", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "industry",
                              placeholder: "Industry",
                              "md-autogrow": ""
                            },
                            on: {
                              input: function($event) {
                                _vm.member.industry = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.industry,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "industry", $$v)
                              },
                              expression: "member.industry"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-helper-text" }, [
                            _vm._v(
                              "Multiple industry must be comma(,) separated"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Bio")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item remove-perfect-tense" },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community textareaAfter" },
                        [
                          _c("md-textarea", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "bio",
                              placeholder: "Bio...",
                              "md-autogrow": ""
                            },
                            on: {
                              input: function($event) {
                                _vm.newBio = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.newBio,
                              callback: function($$v) {
                                _vm.newBio = $$v
                              },
                              expression: "newBio"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Bio Keyword")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item remove-perfect-tense" },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community textareaAfter" },
                        [
                          _c("md-textarea", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "newBioKeyword",
                              placeholder: "Bio Keyword...",
                              "md-autogrow": ""
                            },
                            on: {
                              input: function($event) {
                                _vm.newBioKeyword = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.newBioKeyword,
                              callback: function($$v) {
                                _vm.newBioKeyword = $$v
                              },
                              expression: "newBioKeyword"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-helper-text" }, [
                            _vm._v(
                              "Multiple bio keywords must be comma(,) separated"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("LinkedIn URL")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: false,
                                  regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/
                                },
                                expression:
                                  "{ required: false, regex: /^http(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\'\\/\\\\\\+&%\\$#_]*)?$/ }"
                              }
                            ],
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "linkedInURL",
                              placeholder: "LinkedIn URL"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.linkedIn = _vm.sanitizeUrl($event)
                              }
                            },
                            model: {
                              value: _vm.member.linkedIn,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "linkedIn", $$v)
                              },
                              expression: "member.linkedIn"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has(
                                    "form-profile.linkedInURL"
                                  ),
                                  expression:
                                    "errors.has('form-profile.linkedInURL')"
                                }
                              ],
                              staticClass: "md-helper-text error"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.errors.first("form-profile.linkedInURL")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Skills & Expertise")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item remove-perfect-tense" },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community textareaAfter" },
                        [
                          _c("md-textarea", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "skills",
                              placeholder: "Skills...",
                              "md-autogrow": ""
                            },
                            on: {
                              input: function($event) {
                                _vm.skillsList = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.skillsList,
                              callback: function($$v) {
                                _vm.skillsList = $$v
                              },
                              expression: "skillsList"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-helper-text" }, [
                            _vm._v("Multiple skills must be comma(,) separated")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Interests")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item remove-perfect-tense" },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community textareaAfter" },
                        [
                          _c("md-textarea", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "interests",
                              placeholder: "Interests",
                              "md-autogrow": ""
                            },
                            on: {
                              input: function($event) {
                                _vm.interestList = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.interestList,
                              callback: function($$v) {
                                _vm.interestList = $$v
                              },
                              expression: "interestList"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-helper-text" }, [
                            _vm._v(
                              "Multiple interests must be comma(,) separated"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Marketing Opt-In?")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "marketingOptIn",
                              placeholder: "Marketing Opt-In"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.marketingOptIn = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.marketingOptIn,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "marketingOptIn", $$v)
                              },
                              expression: "member.marketingOptIn"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Race")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "race",
                              placeholder: "Race"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.race = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.race,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "race", $$v)
                              },
                              expression: "member.race"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Gender")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "gender",
                              placeholder: "Gender"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.gender = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.gender,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "gender", $$v)
                              },
                              expression: "member.gender"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Age")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "age",
                              placeholder: "Age"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.age = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.age,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "age", $$v)
                              },
                              expression: "member.age"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Online Calendar URL")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "calendar",
                              placeholder: "Calendar"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.calendar = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.calendar,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "calendar", $$v)
                              },
                              expression: "member.calendar"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Twitter URL")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "twitter",
                              placeholder: "Twitter URL"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.twitter = _vm.sanitizeUrl($event)
                              }
                            },
                            model: {
                              value: _vm.member.twitter,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "twitter", $$v)
                              },
                              expression: "member.twitter"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Instagram URL")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "instagram",
                              placeholder: "Instagram URL"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.instagram = _vm.sanitizeUrl($event)
                              }
                            },
                            model: {
                              value: _vm.member.instagram,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "instagram", $$v)
                              },
                              expression: "member.instagram"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Skype ID")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "skypeID",
                              placeholder: "Skype ID"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.skypeID = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.skypeID,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "skypeID", $$v)
                              },
                              expression: "member.skypeID"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("School 1")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "school1",
                              placeholder: "School 1"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.school1 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.school1,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "school1", $$v)
                              },
                              expression: "member.school1"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Department 1")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "department1",
                              placeholder: "Department 1"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.department1 = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.department1,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "department1", $$v)
                              },
                              expression: "member.department1"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Major 1")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "major1",
                              placeholder: "Major 1"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.major1 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.major1,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "major1", $$v)
                              },
                              expression: "member.major1"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Degree 1")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "degree1",
                              placeholder: "Degree 1"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.degree1 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.degree1,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "degree1", $$v)
                              },
                              expression: "member.degree1"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Year 1")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "year1",
                              placeholder: "Year 1"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.year1 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.year1,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "year1", $$v)
                              },
                              expression: "member.year1"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("School 2")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "school2",
                              placeholder: "School 2"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.school2 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.school2,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "school2", $$v)
                              },
                              expression: "member.school2"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Department 2")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "department2",
                              placeholder: "Department 2"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.department2 = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.department2,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "department2", $$v)
                              },
                              expression: "member.department2"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Major 2")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "major2",
                              placeholder: "Major 2"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.major2 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.major2,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "major2", $$v)
                              },
                              expression: "member.major2"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Degree 2")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "degree2",
                              placeholder: "Degree 2"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.degree2 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.degree2,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "degree2", $$v)
                              },
                              expression: "member.degree2"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Year 2")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "year2",
                              placeholder: "Year 2"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.year2 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.year2,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "year2", $$v)
                              },
                              expression: "member.year2"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("School 3")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "school3",
                              placeholder: "School 3"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.school3 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.school3,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "school3", $$v)
                              },
                              expression: "member.school3"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Department 3")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "department3",
                              placeholder: "Department 3"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.department3 = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.department3,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "department3", $$v)
                              },
                              expression: "member.department3"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Major 3")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "major3",
                              placeholder: "Major 3"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.major3 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.major3,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "major3", $$v)
                              },
                              expression: "member.major3"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Degree 3")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "degree3",
                              placeholder: "Degree 3"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.degree3 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.degree3,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "degree3", $$v)
                              },
                              expression: "member.degree3"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Year 3")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "year3",
                              placeholder: "Year 3"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.year3 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.year3,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "year3", $$v)
                              },
                              expression: "member.year3"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("School 4")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "school4",
                              placeholder: "School 4"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.school4 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.school4,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "school4", $$v)
                              },
                              expression: "member.school4"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Department 4")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "department4",
                              placeholder: "Department 4"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.department4 = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.department4,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "department4", $$v)
                              },
                              expression: "member.department4"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Major 4")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "major4",
                              placeholder: "Major 4"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.major4 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.major4,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "major4", $$v)
                              },
                              expression: "member.major4"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Degree 4")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "degree4",
                              placeholder: "Degree 4"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.degree4 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.degree4,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "degree4", $$v)
                              },
                              expression: "member.degree4"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Year 4")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "year4",
                              placeholder: "Year 4"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.year4 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.year4,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "year4", $$v)
                              },
                              expression: "member.year4"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("School 5")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "school5",
                              placeholder: "School 5"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.school5 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.school5,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "school5", $$v)
                              },
                              expression: "member.school5"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Department 5")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "department5",
                              placeholder: "Department 5"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.department5 = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.department5,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "department5", $$v)
                              },
                              expression: "member.department5"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Major 5")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "major5",
                              placeholder: "Major 5"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.major5 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.major5,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "major5", $$v)
                              },
                              expression: "member.major5"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Degree 5")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "degree5",
                              placeholder: "Degree 5"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.degree5 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.degree5,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "degree5", $$v)
                              },
                              expression: "member.degree5"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Year 5")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "year5",
                              placeholder: "Year 5"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.year5 = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.year5,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "year5", $$v)
                              },
                              expression: "member.year5"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Image URL")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "imageURL",
                              placeholder: "Image URL"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.imageURL = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.imageURL,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "imageURL", $$v)
                              },
                              expression: "member.imageURL"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Website URL")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "website",
                              placeholder: "Website URL"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.website = _vm.sanitizeUrl($event)
                              }
                            },
                            model: {
                              value: _vm.member.website,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "website", $$v)
                              },
                              expression: "member.website"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Facebook URL")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "facebook",
                              placeholder: "Facebook URL"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.facebook = _vm.sanitizeUrl($event)
                              }
                            },
                            model: {
                              value: _vm.member.facebook,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "facebook", $$v)
                              },
                              expression: "member.facebook"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Company Stage")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              name: "companyStage",
                              placeholder: "Company Stage"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.companyStage = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.companyStage,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "companyStage", $$v)
                              },
                              expression: "member.companyStage"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Annual Revenue")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              name: "annualRevenue",
                              placeholder: "Annual Revenue"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.annualRevenue = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.annualRevenue,
                              callback: function($$v) {
                                _vm.$set(_vm.member, "annualRevenue", $$v)
                              },
                              expression: "member.annualRevenue"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Team Size")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: {
                              name: "teamSize",
                              placeholder: "Team Size"
                            },
                            on: {
                              input: function($event) {
                                _vm.member.teamSize = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.teamSize,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.member,
                                  "teamSize",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "member.teamSize"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("WordPress Link")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: { name: "wordPressLink", disabled: "" },
                            on: {
                              input: function($event) {
                                _vm.member.wordPressLink = _vm.sanitizeUrl(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.wordPressLink,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.member,
                                  "wordPressLink",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "member.wordPressLink"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Custom Value 1")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: { name: "Custom Value 1" },
                            on: {
                              input: function($event) {
                                _vm.member.customer_custom1 = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.customer_custom1,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.member,
                                  "customer_custom1",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "member.customer_custom1"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Custom Value 2")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: { name: "Custom Value 2" },
                            on: {
                              input: function($event) {
                                _vm.member.customer_custom2 = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.customer_custom2,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.member,
                                  "customer_custom2",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "member.customer_custom2"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Custom Value 3")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: { name: "Custom Value 3" },
                            on: {
                              input: function($event) {
                                _vm.member.customer_custom3 = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.customer_custom3,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.member,
                                  "customer_custom3",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "member.customer_custom3"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Engagement Points")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: { name: "engagementPoints", disabled: "" },
                            on: {
                              input: function($event) {
                                _vm.member.engagementPoints = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.engagementPoints,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.member,
                                  "engagementPoints",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "member.engagementPoints"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Approved for Requests?")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community w-50" },
                        [
                          _c(
                            "md-select",
                            {
                              staticClass: "capitalize",
                              attrs: {
                                disabled: _vm.member.isDeleted.status == true,
                                name: "requestStatus",
                                placeholder: "Approved for Requests?",
                                id: "requestStatus"
                              },
                              on: {
                                "md-closed": function($event) {
                                  return _vm.saveDetail2(
                                    "requestStatus",
                                    _vm.requestStatus
                                  )
                                }
                              },
                              model: {
                                value: _vm.requestStatus,
                                callback: function($$v) {
                                  _vm.requestStatus =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "requestStatus"
                              }
                            },
                            [
                              _c("md-option", { attrs: { value: "yes" } }, [
                                _vm._v("Yes")
                              ]),
                              _vm._v(" "),
                              _c("md-option", { attrs: { value: "no" } }, [
                                _vm._v("No")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Approved for responses?")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community w-50" },
                        [
                          _c(
                            "md-select",
                            {
                              staticClass: "capitalize",
                              attrs: {
                                disabled: _vm.member.isDeleted.status == true,
                                name: "responseStatus",
                                placeholder: "Approved for responses?",
                                id: "responseStatus"
                              },
                              on: {
                                "md-closed": function($event) {
                                  return _vm.saveDetail2(
                                    "responseStatus",
                                    _vm.responseStatus
                                  )
                                }
                              },
                              model: {
                                value: _vm.responseStatus,
                                callback: function($$v) {
                                  _vm.responseStatus =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "responseStatus"
                              }
                            },
                            [
                              _c("md-option", { attrs: { value: "yes" } }, [
                                _vm._v("Yes")
                              ]),
                              _vm._v(" "),
                              _c("md-option", { attrs: { value: "no" } }, [
                                _vm._v("No")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Terms Accepted")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community w-50" },
                        [
                          _vm.member.termsAccepted
                            ? _c("md-input", {
                                attrs: {
                                  value: _vm._f("momentDate")(
                                    _vm.member.termsAccepted
                                  ),
                                  name: "termsAccepted",
                                  disabled: ""
                                },
                                on: {
                                  input: function($event) {
                                    _vm.member.termsAccepted = _vm.sanitizeInput(
                                      $event
                                    )
                                  }
                                }
                              })
                            : _c("md-input", {
                                attrs: { name: "termsAccepted", disabled: "" }
                              })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Frequency")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community w-50" },
                        [
                          _c(
                            "md-select",
                            {
                              staticClass: "capitalize",
                              attrs: {
                                name: "frequency",
                                placeholder: "Frequency"
                              },
                              on: {
                                "md-closed": function($event) {
                                  return _vm.saveDetail2(
                                    "frequency",
                                    _vm.frequency
                                  )
                                }
                              },
                              model: {
                                value: _vm.frequency,
                                callback: function($$v) {
                                  _vm.frequency =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "frequency"
                              }
                            },
                            _vm._l(_vm.availableFrequncy, function(frequency) {
                              return _c(
                                "md-option",
                                { key: frequency, attrs: { value: frequency } },
                                [_vm._v(_vm._s(_vm.toTitleCase(frequency)))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Engagement")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: { name: "engagement" },
                            on: {
                              input: function($event) {
                                _vm.member.engagement = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.engagement,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.member,
                                  "engagement",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "member.engagement"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Capacity")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: { name: "capacity" },
                            on: {
                              input: function($event) {
                                _vm.member.capacity = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.member.capacity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.member,
                                  "capacity",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "member.capacity"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Propensity")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community" },
                        [
                          _c("md-input", {
                            attrs: { name: "propensity" },
                            on: {
                              input: function($event) {
                                _vm.member.propensity = _vm.sanitizeInput(
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.member.propensity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.member,
                                  "propensity",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "member.propensity"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Member Status")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community w-50" },
                        [
                          _c(
                            "md-select",
                            {
                              staticClass: "capitalize",
                              attrs: {
                                name: "member_status",
                                placeholder: "member_status"
                              },
                              on: {
                                "md-closed": function($event) {
                                  return _vm.saveDetail2(
                                    "member_status",
                                    _vm.member_status
                                  )
                                }
                              },
                              model: {
                                value: _vm.member_status,
                                callback: function($$v) {
                                  _vm.member_status =
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                },
                                expression: "member_status"
                              }
                            },
                            [
                              _c("md-option", { attrs: { value: true } }, [
                                _vm._v("Active")
                              ]),
                              _vm._v(" "),
                              _c("md-option", { attrs: { value: false } }, [
                                _vm._v("Inactive")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-row" }, [
                  _c("div", { staticClass: "card-item md-subheading mt-30" }, [
                    _vm._v("Account Owner")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "md-layout-item remove-perfect-tense" },
                    [
                      _c(
                        "md-field",
                        { staticClass: "create-community textareaAfter" },
                        [
                          _c("md-textarea", {
                            attrs: {
                              disabled: _vm.member.isDeleted.status == true,
                              name: "account_owner",
                              placeholder: "Account Owner...",
                              "md-autogrow": ""
                            },
                            on: {
                              input: function($event) {
                                _vm.accountOwnerList = _vm.sanitizeInput($event)
                              }
                            },
                            model: {
                              value: _vm.accountOwnerList,
                              callback: function($$v) {
                                _vm.accountOwnerList = $$v
                              },
                              expression: "accountOwnerList"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-helper-text" }, [
                            _vm._v(
                              "Multiple account owner must be comma(,) separated"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-row cardbtndel pull-right" },
                  [
                    _vm.member.isDeleted.status == false ||
                    typeof _vm.member.isDeleted == "undefined"
                      ? _c(
                          "md-button",
                          {
                            staticClass:
                              "md-button md-red md-round md-accent md-theme-default",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.deleteMember()
                              }
                            }
                          },
                          [_vm._v("Delete Member")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_vm._v("Requests:"), _c("br"), _vm._v("Last Request:")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _vm._v("Last Request Received:"),
      _c("br"),
      _vm._v("Next Engagement Date:")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_vm._v("Responses:"), _c("br"), _vm._v("Last Response:")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5682ba2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5682ba2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MemberProfile.vue
// module id = null
// module chunks = 